// public-site/src/theme.js
// Brand palette + reusable style objects for sdfhpay.com.
// Visual language mirrors the LIFT staff login: a navy "LIFT blue" panel with a
// warm-gold accent and a white primary button, in EB Garamond. Earl Test holds
// (18px text, 56px inputs, 60px buttons). All four screens import from here, so
// this file drives the look.

import typography from './typography';

// Funeral home identity for customer-facing disclosures (recurring-payment
// authorization, etc.). The phone matches the number printed on SDFH receipts —
// the public business line, not a secret.
export const MERCHANT_NAME = 'Stephenson-Dearman Funeral Home';
export const SUPPORT_PHONE = '(870) 367-2451';

export const colors = {
  // Brand — navy "LIFT blue" + warm gold (from the staff app)
  navy: '#1B3A5C',
  navyDeep: '#14304D',
  navyGradient: 'linear-gradient(180deg, #1B3A5C 0%, #14304D 100%)',
  gold: '#D4C5A9', // warm tan — labels, links, accents
  goldStrong: '#B09030',
  white: '#FFFFFF',

  pageBg: '#14304D',
  // Translucent text on navy (high-contrast, dignified)
  textPrimary: '#FFFFFF',
  textSecondary: 'rgba(255,255,255,0.82)',
  textMuted: 'rgba(255,255,255,0.62)',
  link: '#D4C5A9',

  // Translucent surfaces + inputs on navy
  nested: 'rgba(255,255,255,0.06)',
  inputBg: 'rgba(255,255,255,0.12)',
  inputBorder: 'rgba(255,255,255,0.28)',
  inputFocus: 'rgba(255,255,255,0.65)',
  hairline: 'rgba(212,197,169,0.28)', // gold hairline divider/border

  error: '#FECACA',
  warning: '#D97706',

  // Legacy aliases (a few screen accents still reference these) → gold on navy
  green: '#D4C5A9',
  blue: '#D4C5A9',
  borderInput: 'rgba(255,255,255,0.28)',
};

export const styles = {
  page: {
    minHeight: '100vh',
    background: colors.navyGradient,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '28px 16px 40px',
  },
  card: {
    width: '100%',
    maxWidth: '420px',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 100%)',
    borderRadius: '18px',
    border: `1px solid ${colors.hairline}`,
    boxShadow: '0 18px 50px rgba(0,0,0,0.35)',
    padding: '28px 24px',
  },
  title: {
    ...typography.pageTitle,
    color: colors.textPrimary,
    margin: '0 0 8px',
  },
  bodyText: {
    ...typography.body,
    color: colors.textSecondary,
    margin: '0 0 16px',
  },
  label: {
    ...typography.label,
    color: colors.gold,
    display: 'block',
    marginBottom: '8px',
  },
  input: {
    ...typography.input,
    width: '100%',
    height: '56px',
    padding: '0 16px',
    borderRadius: '10px',
    border: `2px solid ${colors.inputBorder}`,
    color: colors.white,
    background: colors.inputBg,
    outline: 'none',
    marginBottom: '16px',
  },
  // The "white button like LIFT" — white fill, navy text.
  buttonPrimary: {
    ...typography.buttonLg,
    width: '100%',
    minHeight: '60px',
    border: 'none',
    borderRadius: '12px',
    background: colors.white,
    color: colors.navyDeep,
    boxShadow: '0 6px 18px rgba(0,0,0,0.28)',
  },
  // Ghost button — transparent with a translucent white outline.
  buttonSecondary: {
    ...typography.buttonLg,
    width: '100%',
    minHeight: '60px',
    borderRadius: '12px',
    background: 'transparent',
    color: colors.white,
    border: `2px solid ${colors.inputBorder}`,
  },
  errorBox: {
    ...typography.error,
    color: colors.error,
    background: 'rgba(220,38,38,0.15)',
    border: '1px solid rgba(248,113,113,0.45)',
    borderRadius: '10px',
    padding: '12px 14px',
    marginBottom: '18px',
  },
};
